import { render } from "./ExampleDeviceScreenListLinks.vue?vue&type=template&id=717b938c&scoped=true&lang=pug"
const script = {}

import "./ExampleDeviceScreenListLinks.vue?vue&type=style&index=0&id=717b938c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-717b938c"]])

export default __exports__